//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {		
	data () {
		return {
			value: '',
			isPopShow: false
		}
	},

	computed: {
		isFooterActive() {
			return this.value !== '';
		},
		isBtnDisbaled() {
			let re = /^[a-z0-9A-Z]{6,32}$/;
			return !re.test(this.value)
		}
	},

	methods: {
			
	},

	created () {

	},

	mounted () {
		
	},
}



// WEBPACK FOOTER //
// ./src/views/password/password.vue